import IntensityMeter from '@nespresso/catalog-components-react/controls/IntensityMeter';
import { MAXIMUM_COFFEE_INTENSITY, type Product } from '@/domain/Product';
import styles from './CoffeeIntensity.module.scss';
import {
  getKnownProductSpecificationByKey,
  type PropertySpecification
} from '@/domain/Specification';

interface CoffeeIntensityProps {
  product: Product;
}

export default function CoffeeIntensity({ product }: CoffeeIntensityProps) {
  const { specifications } = product;

  const intensitySpec = getKnownProductSpecificationByKey<
    PropertySpecification | undefined // could be undefined in theory
  >(specifications, 'intensity');

  if (intensitySpec === undefined) {
    return null;
  }

  const intensityLabel = intensitySpec.title;
  const intensityValue = Number(intensitySpec.value);
  // hide intensity meter for products which don't have a value, such as assortments
  if (Number.isNaN(intensityValue) || intensityValue === 0) {
    return null;
  }

  return (
    <div class={styles.container}>
      <IntensityMeter
        label={intensityLabel}
        intensity={intensityValue}
        maximum={MAXIMUM_COFFEE_INTENSITY}
        showLabel
      />
    </div>
  );
}
